module.exports = __webpack_public_path__ + "static/media/jean_carlos_lourenco_costa.b341d3c6.jpg";